import React from 'react'

import { PostbackDetails } from './PostbackDetails'
import { PostbackCreationInfo } from '../../models/Postback'

const defaultData = {
  name: '',
  partnerTypeId: '',
  impressionUrl: '',
  clickUrl: '',
}

interface CreateOrEditPostbackFormProps {
  initialData?: PostbackCreationInfo
  type: 'create' | 'edit'
  onCompletion: (data: PostbackCreationInfo) => void
  isCompletionInProgress?: boolean
  onClose: () => void
}

export const CreateOrEditPostbackForm = ({
  initialData = defaultData,
  type,
  onCompletion,
  isCompletionInProgress,
  onClose,
}: CreateOrEditPostbackFormProps) => {
  const [postbackInfo, setPostbackInfo] = React.useState(initialData)

  return (
    <PostbackDetails
      onClose={onClose}
      type={type}
      postbackInfo={postbackInfo}
      setPostbackInfo={setPostbackInfo}
      onCompletion={onCompletion}
      isCompletionInProgress={isCompletionInProgress}
    />
  )
}
